<vp-mini-carousel
	[aspectRatio]="aspectRatio"
	[config]="config"
	[editableInStoryblok]="_editable()"
	[items]="carouselItems"
/>
